import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SystemSettingsService } from './system-settings.service';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';

@Component({
  selector: 'app-system-settings',
  templateUrl: './system-settings.component.html',
  styleUrls: ['./system-settings.component.scss'],
  standalone: false
})
export class SystemSettingsComponent implements DirtyCheck {
  title: string = "System Settings";
  editForm: FormGroup;
  isFormDirty: boolean = false;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private settingsService: SystemSettingsService,
    private snackBarService: SnackBarService
  ) {
    this.editForm = this.builder.group({
      unavilable_bg_color: ['#ffcccc'],
      leave_bg_color: ['#ccffcc'],
      rostered_hour_color: ['#3182ce'],
      actual_hour_color: ['#000000'],
      att_threshold_in_before: [7],
      att_threshold_in_after: [7],
      att_threshold_out_before: [7],
      att_threshold_out_after: [7]
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    this.loadSettings();
  }

  isDirty(): boolean {
    return this.isFormDirty;
  }

  navBack(): void {
    this.router.navigate(['/system/job-position']);
  }

  loadSettings(): void {
    this.settingsService.getSettings().subscribe({
      next: (response) => {
        if (response.status === 'SUCCESS' && response.data.settings) {
          const settings = response.data.settings;
          this.editForm.patchValue({
            unavilable_bg_color: settings.unavilable_bg_color || '#ffcccc',
            leave_bg_color: settings.leave_bg_color || '#ccffcc',
            rostered_hour_color: settings.rostered_hour_color || '#3182ce',
            actual_hour_color: settings.actual_hour_color || '#000000',
            att_threshold_in_before: settings.att_threshold_in_before !== null ? Number(settings.att_threshold_in_before) : 7,
            att_threshold_in_after: settings.att_threshold_in_after !== null ? Number(settings.att_threshold_in_after) : 7,
            att_threshold_out_before: settings.att_threshold_out_before !== null ? Number(settings.att_threshold_out_before) : 7,
            att_threshold_out_after: settings.att_threshold_out_after !== null ? Number(settings.att_threshold_out_after) : 7
          });
          this.isFormDirty = false;
        }
      }
    });
  }

  save(): void {
    if (this.editForm.valid) {
      this.settingsService.saveSettings(this.editForm.value).subscribe({
        next: (response) => {
          if (response.status === 'SUCCESS') {
            this.isFormDirty = false;
            this.snackBarService.openSnackBar({
              type: 'success',
              title: 'Saved',
              message: 'System settings have been updated successfully.'
            });
          } else {
            this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
          }
        }
      });
    }
  }
}
